import React from 'react';
import PropTypes from 'prop-types';

import WaldogramMainPhotoPlaceholder from './WaldogramMainPhotoPlaceholder';
import WaldogramSecondaryPhotoPlaceholder from './WaldogramSecondaryPhotoPlaceholder';
import WaldogramAddressPlaceholder from './WaldogramAddressPlaceholder';
import WaldogramMessageInput from './WaldogramMessageInput';
import { WALDOGRAM_PRINT_TYPE } from '../../../apps/web-gallery/constants/web-gallery-waldogram-constants';

const propTypes = {
  config: PropTypes.shape({
    emoji: PropTypes.shape({
      id: PropTypes.string,
      unified: PropTypes.string,
    }),
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        photo: PropTypes.shape({
          id: PropTypes.string,
          position: PropTypes.number,
        }),
      }),
    ),
  }),
  onPhotoSelect: PropTypes.func.isRequired,
  onPhotoCropboxSet: PropTypes.func.isRequired,
  onCaptionSet: PropTypes.func.isRequired,
  onCabinNameSet: PropTypes.func,
  onIdentityNameSet: PropTypes.func.isRequired,
  onEmojiSet: PropTypes.func.isRequired,
  mainSlotRef: PropTypes.object,
};

const WaldogramOneSidedTemplate = ({
  config,
  onPhotoSelect,
  onPhotoCropboxSet,
  onCaptionSet,
  onCabinNameSet,
  onIdentityNameSet,
  onEmojiSet,
  mainSlotRef,
}) => {
  const { photos } = config;
  const mainPhoto = photos.find(photo => photo.position === 0);
  const secondaryPhoto = photos.find(photo => photo.position === 1);

  return (
    <div className="waldogram-template-wrap waldogram-template-onesided">
      <div className="waldogram-template">
        <div ref={mainSlotRef} className="waldogram-template-slot-a">
          <WaldogramMainPhotoPlaceholder
            photo={mainPhoto.photo}
            cropbox={mainPhoto.cropbox}
            onPhotoSelect={onPhotoSelect}
            onPhotoCropboxSet={onPhotoCropboxSet}
          />
        </div>

        <div className="waldogram-template-slot-b">
          <WaldogramAddressPlaceholder
            onCabinNameSet={onCabinNameSet}
            onIdentityNameSet={onIdentityNameSet}
            identityName={config.identityName}
            cabinName={config.cabinName}
          />
        </div>

        <div className="waldogram-template-slot-c">
          <WaldogramSecondaryPhotoPlaceholder
            photo={secondaryPhoto.photo}
            emoji={config.emoji}
            onPhotoSelect={onPhotoSelect}
            onPhotoCropboxSet={onPhotoCropboxSet}
            onEmojiSet={onEmojiSet}
          />
        </div>

        <div className="waldogram-template-slot-d">
          <WaldogramMessageInput
            onChange={onCaptionSet}
            value={config.caption}
            type={WALDOGRAM_PRINT_TYPE.ONSITE}
          />
        </div>
      </div>
    </div>
  );
};

WaldogramOneSidedTemplate.propTypes = propTypes;

export default WaldogramOneSidedTemplate;
